import { Text, UnstyledButton } from '@buffer-mono/popcorn'
import {
  BufferTrackerReact as BufferTracker,
  Product,
} from '@buffer-mono/tracking-plan'

import { useNotesCtaView } from '~publish/components/NotesWidget'
import { useAccount, useCanStartTrial } from '~publish/contexts/AccountContext'
import { MODALS, useOpenGlobalModal } from '~publish/hooks/useOpenGlobalModal'
import { selectCurrentOrganizationId } from '~publish/legacy/organizations/selectors'
import { useAppSelector } from '~publish/legacy/store'

import styles from './UpgradeToTeamPlan.module.css'

import type { JSX } from 'react'

export const UpgradeToTeamPlan = (): JSX.Element => {
  const { account } = useAccount()
  const organizationId = useAppSelector(selectCurrentOrganizationId)
  const canStartTrial = useCanStartTrial()
  const openGlobalModal = useOpenGlobalModal()

  const view = useNotesCtaView()
  const state = canStartTrial ? 'trial' : 'upgrade'
  const cta = `${view}-notesFeed-${state}-1`
  const commonTrackingProperties =
    account?.currentOrganization?.commonTrackingProperties || null

  const handleUpgradePathClick = (): void => {
    if (canStartTrial) {
      openGlobalModal(MODALS.startTrial, {
        ctaView: view,
        ctaLocation: 'post',
        ctaButton: 'startA14DaysFreeTrial',
        cta,
        upgradePathName: 'notesFeed-trial',
      })
    } else {
      openGlobalModal(MODALS.planSelector, {
        cta,
        upgradePathName: `notesFeed-upgrade`,
      })
    }
    BufferTracker.cTAClicked({
      organizationId,
      product: Product.Publish,
      cta,
      clientName: 'publishWeb',
      upgradePathName: `notesFeed-${state}`,
      ...commonTrackingProperties,
    })
  }

  return (
    <aside className={styles.upgradeContainer}>
      <img
        alt="Collaboration icons"
        src="https://buffer-publish.s3.amazonaws.com/images/collaboration-icons.svg"
      />
      {canStartTrial ? (
        <Text as="p">
          Want to collaborate with your team using Notes?
          <UnstyledButton
            className={styles.button}
            onClick={handleUpgradePathClick}
          >
            Start a 14-day free trial,
          </UnstyledButton>
          <span> no credit card required.</span>
        </Text>
      ) : (
        <Text as="p">
          <UnstyledButton
            className={styles.button}
            onClick={handleUpgradePathClick}
          >
            Invite your team
          </UnstyledButton>
          <span> to share and receive notes.</span>
        </Text>
      )}
    </aside>
  )
}
